import moment from 'moment'

export const SET_QUERY = 'dispatches/SET_QUERY'
export const SET_RANGE = 'dispatches/SET_RANGE'
export const SET_TYPE = 'dispatches/SET_TYPE'
export const SET_STATUS = 'dispatches/SET_STATUS'
export const SET_CREATED_BY_ME = 'dispatches/SET_CREATED_BY_ME'

let initialState = {
  query: undefined,
  range: [moment(), moment()],
  type: undefined,
  status: undefined,
  createdByMe: true
}

const storageValues = [
  { name: 'createdByMe', parse: true },
]

storageValues.forEach(i => {
  const localValue = localStorage.getItem(i.name)

  if (localValue) {
    initialState[i.name] = i.parse ? JSON.parse(localValue) : localValue
  }
})

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_QUERY:
      return {
        ...state,
        query: action.query
      }

    case SET_RANGE:
      return {
        ...state,
        range: action.range
      }

    case SET_TYPE:
      return {
        ...state,
        type: action.dispatchType
      }

    case SET_STATUS:
      return {
        ...state,
        status: action.status
      }

    case SET_CREATED_BY_ME:
      localStorage.setItem('createdByMe', JSON.stringify(action.createdByMe))
      return {
        ...state,
        createdByMe: action.createdByMe
      }

    default:
      return state
  }
}

export const setQuery = (query) => {
  return dispatch => {
    dispatch({
      type: SET_QUERY,
      query
    })
  }
}

export const setRange = (range) => {
  return dispatch => {
    dispatch({
      type: SET_RANGE,
      range
    })
  }
}

export const setType = (dispatchType) => {
  return dispatch => {
    dispatch({
      type: SET_TYPE,
      dispatchType
    })
  }
}

export const setStatus = (status) => {
  return dispatch => {
    dispatch({
      type: SET_STATUS,
      status
    })
  }
}

export const setCreatedByMe = (createdByMe) => {
  return dispatch => {
    dispatch({
      type: SET_CREATED_BY_ME,
      createdByMe
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/search.js